'use strict';
const angular = require('angular');

export class testimonialsWidgetComponent {

  constructor(TestimonialService) {
    'ngInject';

    this.TestimonialService = TestimonialService;
  }

  $onInit() {
    this.TestimonialService.query(data => {
      let _count = this.count || 3;
      this.data = data.filter(t => t.meta.active).slice(0, _count);
    }, err => {
      console.log('could not retrieve newest testimonials');
    });
  }
}

export default angular.module('conduuApp.testimonialsWidget', [])
  .component('testimonialsWidget', {
    template: require('./testimonials-widget.component.html'),
    bindings: {
      count: '@'
    },
    controller: testimonialsWidgetComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/sidebar/testimonials-widget/testimonials-widget.component.js